<app-expandable-section-box
  [title]="'Enable Branding'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 w-full pt-1" expandedContent>
    <div class="flex flex-row flex-1 w-full">
      <div class="w-1/6 pt-6">
        <mat-icon
          class="justify-center align-middle"
          fontIcon="lens"
          [ngStyle]="{ color: control.value }"
        ></mat-icon>
      </div>
      <div class="w-5/6">
        <mat-form-field>
          <input
            type="text"
            matInput
            [name]="'ColourHex'"
            [formControl]="control"
            placeholder="Colour (Hex)"
            class="w-5/6 text-lg"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div
    class="flex flex-col w-full py-2 pr-3 m-0 bg-project-2200"
    notExpandedContent
  >
    <p class="w-full text-xs font-bold">Colour</p>
    <div class="w-full text-sm">
      <mat-icon
        class="align-bottom"
        fontIcon="lens"
        [ngStyle]="{ color: control.value }"
      ></mat-icon>
      {{ control.value }}
    </div>
  </div>
</app-expandable-section-box>
